// @givmo/employer-module — Terms / Privacy acceptance warning (ports `terms_and_policy_warning.dart`).
//
// The copy: "By {action}, I agree to Givmo’s Terms of Use & Privacy Policy." — "Terms of Use"
// (https://givmocharitable.org/terms) and "Privacy Policy" (https://givmocharitable.org/privacy)
// open in a new tab (the Flutter `_blank`). The sign-up chooser passes action="registering".
//
// ONE sentence in both hosts, set as their doors' footnotes are (a typographic apostrophe, a closing
// full stop), each link's name kept on one line. Where it sits is the host's look (`look.terms`): the
// portal centres it under a hairline, as its sign-in chooser sets its last line (EP-WEB43; until
// then it drew the Flutter port's two centred lines); the console sets it quietly under the ways in.

import { useSignUpHost } from './sign-up-host';

export interface TermsPolicyWarningProps {
  /** The verb in "By {action}, I agree…" (chooser uses "registering"). */
  action: string;
}

const TERMS_URL = 'https://givmocharitable.org/terms';
const PRIVACY_URL = 'https://givmocharitable.org/privacy';

export function TermsPolicyWarning({ action }: TermsPolicyWarningProps) {
  const { look } = useSignUpHost();
  return (
    <p className={look.terms}>
      {`By ${action}, I agree to Givmo’s `}
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noreferrer"
        className="whitespace-nowrap font-w600 text-brand-600 outline-none transition-colors hover:text-brand-700 focus-visible:underline"
      >
        Terms of Use
      </a>
      {' & '}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noreferrer"
        className="whitespace-nowrap font-w600 text-brand-600 outline-none transition-colors hover:text-brand-700 focus-visible:underline"
      >
        Privacy Policy
      </a>
      .
    </p>
  );
}
